export default __webpack_public_path__ + "static/media/gallery-6-2.2f145d9f.webp";